import { HeroWithSearch as HygraphHeroWithSearch } from '@/lib/types';

import HeroWithSearch, {
  HeroWithSearchProps,
} from '@/components/hero-with-search';
import { ResponsiveHygraphImageProps } from '@/components/responsive-hygraph-image';

import responsiveHygraphImageTransformer from '@/hygraph/transformers/responsive-image.transformer';

// TODO: Do we need anything for the schema?
// HeroWithSearchRenderer.buildSchema = buildSchema;
// function buildSchema(
//   component: HygraphContentSectionWithImageRow
// ): Partial<TSchemaData<Thing>> {
//   const url = component.image?.url;
//   return { images: url ? [url] : [] };
// }

export default function HeroWithSearchRenderer(props: HygraphHeroWithSearch) {
  let backgroundImages: ResponsiveHygraphImageProps[] | undefined = undefined;
  if (props.backgroundImages?.length > 0) {
    // Tranform all background images and remove the ones that didnt
    backgroundImages = props.backgroundImages
      .map((image) => responsiveHygraphImageTransformer(image))
      .filter((b): b is ResponsiveHygraphImageProps => b !== undefined);
  }

  const componentProps: HeroWithSearchProps = {
    caption: props.caption || '',
    title: props.title || '',
    backgroundImages,
  };

  return <HeroWithSearch {...componentProps} />;
}
